import { BefraktareDto } from "./BefraktareDto";
import { StyrtabellLanKommunDistriktDTO } from "./StyrtabellLanKommunDistriktDTO";
import { StyrtabellVerksamhetsomradeDTO } from "./StyrtabellVerksamhetsomradeDTO";

export class StyrtabellMatningsinformationDto {
    id: number;
    guid: string;
    inmatningshandelssortiment: string;
    transportslag: string;
    befraktare: BefraktareDto;
    anskaffningsform: string[];
    affarsform: string[];
    verksamhetsomraden: StyrtabellVerksamhetsomradeDTO[];
    lanKommunDistrikt: StyrtabellLanKommunDistriktDTO[];
    mattslag: string;
    andraMattslag?: boolean;
    stockmatningKravs?: boolean;
    kvalitetsklassningKravs?: boolean;
    prioriteradMatmetod: string;
    constructor() {
        this.id = undefined;
        this.guid = undefined;
        this.befraktare = undefined;
        this.inmatningshandelssortiment = undefined;
        this.transportslag = undefined;
        this.anskaffningsform = undefined;
        this.affarsform = undefined;
        this.verksamhetsomraden = undefined;
        this.lanKommunDistrikt = undefined;
        this.mattslag = undefined;
        this.andraMattslag = undefined;
        this.stockmatningKravs = undefined;
        this.kvalitetsklassningKravs = undefined;
        this.prioriteradMatmetod = undefined;
    }
}
